import QTable from 'quasar/src/components/table/QTable.js';

export const adminDepositBankAccountIndexPageTableColumn = (): QTable['columns'] => [
  {
    name: 'title',
    field: 'title',
    label: 'عنوان',
    classes: 'max-width-200',
    align: 'left'
  },
  {
    name: 'account_type',
    field: 'account_type',
    label: 'نوع حساب',
    align: 'center'
  },
  {
    name: 'account_owner_name',
    field: 'account_owner_name',
    label: 'صاحب حساب',
    classes: 'max-width-200',
    align: 'center'
  },
  {
    name: 'sheba',
    field: 'sheba',
    label: 'شماره شبا',
    align: 'center'
  },
  {
    name: 'status',
    field: 'status',
    label: 'وضعیت',
    align: 'center'
  },
  {
    name: 'default',
    field: 'default',
    label: 'پیشفرض',
    align: 'center'
  },
  {
    name: 'actions',
    field: '',
    label: '',
    align: 'center'
  }
]
